import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RfpProfessionalListCallingCard } from '@/components/modules/pages/rfp/professional/Surface/RfpProfessionalListCallingCard/RfpProfessionalListCallingCard';
import { RfpProfessionalListCallingCardSkeleton } from '@/components/modules/pages/rfp/professional/Surface/RfpProfessionalListCallingCardSkeleton';
import { Card } from '@/components/ui/Surface/Card';
import { Text } from '@/components/ui/Typography/Body/Text';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/**
 * コンサルタント：案件一覧のコンテンツ部分の表示
 * @param props
 * @constructor
 */
export const RfpProfessionalListContent = (props) => {
    const { className = '', loading, rfps = [] } = props;
    /** スケルトン表示用のダミー配列 */
    const dummies = useArrayWithIndex(4);
    // ローディングの状態に応じてコンポーネントを切り返る
    return (_jsx("div", Object.assign({ className: clsx('flex flex-col gap-y-20', className) }, { children: (() => {
            // ローディング表示
            if (loading) {
                return dummies.map(({ index }) => (_jsx(RfpProfessionalListCallingCardSkeleton, {}, index)));
            }
            // 0件表示
            if (rfps.length <= 0) {
                return (_jsx(Card, Object.assign({ className: clsx('w-full h-[200px] flex justify-center items-center'), isRounded: true, isShadow: false }, { children: _jsx(Text, Object.assign({ className: 'text-center', color: 'base', size: 'md', tagName: 'div' }, { children: "\u53EA\u4ECA\u3001\u52DF\u96C6\u4E2D\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306F\u3042\u308A\u307E\u305B\u3093" })) })));
            }
            // 通常表示
            return rfps.map((rfp) => (_jsx(RfpProfessionalListCallingCard, { budget: rfp.budget, callEndDate: rfp.call_end_date, clientOrganizationName: rfp.client_organization_name, dataType: rfp.data_type, daysLeft: rfp.days_left, department: rfp.department, endDate: rfp.end_date, icons: rfp.icons, id: rfp.id, isDisclose: rfp.is_disclose, isNegotiable: rfp.is_negotiable, isNegotiableBudget: rfp.is_negotiable_budget, isNegotiableEndDate: rfp.is_negotiable_end_date, isNegotiableStartDate: rfp.is_negotiable_start_date, isNew: rfp.is_new, isProposalRequest: rfp.is_proposal_request, isUrgent: rfp.is_urgent, maxBudget: rfp.max_budget, name: rfp.name, requestComment: rfp.request_comment, startDate: rfp.start_date }, `RfpListRow_${rfp.id}`)));
        })() })));
};
